<template>
  <EditItem
    model="herd-item"
    :item="item"
    :status="status"
    :fields="fields"
  >
    <FormHerdItemEdit
      :item="item"
      :id="id"
    />
  </EditItem>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import EditItem from '../../layouts/EditItem/EditItem';
import FormHerdItemEdit from '../../components/FormHerdItemEdit/FormHerdItemEdit';
import { currency } from '../../utils/helpers';


export default {
  name: 'HerdItemEdit',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      num: 1,
      fields: [
        'name',
        'group_name',
        'price',
        'condition',
        'status',
        'purchase_date',
        'sold_to',
        'sold_date',
        'asking_price',
        'sale_price',
        'notes',
      ]
    };
  },
  components: {
    FormHerdItemEdit,
    EditItem
  },
  mounted() {
    if (!Object.keys(this.item).length && this.id) {
      this.FETCH({ id: this.id });
    }
  },
  computed: {
    ...mapState('herdItem', ['status']),
    ...mapGetters('herdItem', ['getItemById']),
    item() {
      const item = {...this.getItemById(this.id)}

      if (item) {
        item.group_name = item.grouping.name;
        item.price = currency(item.price);
        return item;
      }

      return {};
    },
  },
  methods: {
    ...mapActions('herdItem', ['FETCH']),
  },
  watch: {
    id() {
      this.FETCH({ id: this.id });
    },
  }
};
</script>

<style>
.herd-item-data {
  padding: 10px;
}
</style>
